/* eslint-disable no-underscore-dangle */
import React from 'react';

import FastForwardOutlinedIcon from '@mui/icons-material/FastForwardOutlined';
import FastRewindOutlinedIcon from '@mui/icons-material/FastRewindOutlined';
import PauseOutlinedIcon from '@mui/icons-material/PauseOutlined';
import PlayIcon from '@mui/icons-material/PlayArrow';
import SkipNextOutlinedIcon from '@mui/icons-material/SkipNextOutlined';
import SkipPreviousOutlinedIcon from '@mui/icons-material/SkipPreviousOutlined';
import { Typography } from '@mui/material';

import { CustomMenuButton } from './style';

export type SkipTimeButtonProps = {
  onSkipTimeClick: (time: number) => void;
  onNextChapterClick?: () => void;
  onPrevChapterClick?: () => void;
  onPlayPauseButtonClick: () => void;
  stateCurriculum: string;
  skipTime?: number;
  isPaused: boolean;
  isShowNextChapterButton: boolean;
  isShowPreviousChapterButton: boolean;
};

export const DEFAULT_SKIP_TIME = 15;

const CustomMenu = ({
  onSkipTimeClick,
  onNextChapterClick,
  onPrevChapterClick,
  onPlayPauseButtonClick,
  skipTime,
  isPaused,
  isShowNextChapterButton,
  isShowPreviousChapterButton,
}: SkipTimeButtonProps) => (
  <>
    {onPrevChapterClick && isShowPreviousChapterButton && (
      <CustomMenuButton
        className="vjs-control vjs-button vjs-custom-menu"
        onClick={onPrevChapterClick}
        sx={{
          left: '8%',
        }}
      >
        <SkipPreviousOutlinedIcon sx={{ fontSize: '1.5em' }} />
      </CustomMenuButton>
    )}
    <CustomMenuButton
      className="vjs-control vjs-button vjs-custom-menu"
      onClick={() => onSkipTimeClick(-(skipTime || DEFAULT_SKIP_TIME))}
      sx={{
        left: '25%',
      }}
    >
      <FastRewindOutlinedIcon sx={{ fontSize: '1.25em' }} />
      <Typography variant="caption" fontSize={18} lineHeight={1}>
        {skipTime || DEFAULT_SKIP_TIME}
      </Typography>
    </CustomMenuButton>
    <CustomMenuButton
      className="vjs-control vjs-button vjs-custom-menu play-pause-button"
      onClick={onPlayPauseButtonClick}
    >
      {isPaused ? <PlayIcon sx={{ fontSize: '1.25em' }} /> : <PauseOutlinedIcon sx={{ fontSize: '1.25em' }} />}
    </CustomMenuButton>
    <CustomMenuButton
      className="vjs-control vjs-button vjs-custom-menu"
      onClick={() => onSkipTimeClick(skipTime || DEFAULT_SKIP_TIME)}
      sx={{
        right: '25%',
      }}
    >
      <FastForwardOutlinedIcon sx={{ fontSize: '1.25em' }} />
      <Typography variant="caption" fontSize={18} lineHeight={1}>
        {skipTime || DEFAULT_SKIP_TIME}
      </Typography>
    </CustomMenuButton>
    {onNextChapterClick && isShowNextChapterButton && (
      <CustomMenuButton
        className="vjs-control vjs-button vjs-custom-menu"
        onClick={onNextChapterClick}
        sx={{
          right: '8%',
        }}
      >
        <SkipNextOutlinedIcon sx={{ fontSize: '1.5em' }} />
      </CustomMenuButton>
    )}
  </>
);

export default CustomMenu;
